export var ToastCssClass;
(function (ToastCssClass) {
    ToastCssClass["Base"] = "iress-toast";
    ToastCssClass["Active"] = "iress-toast--active";
    ToastCssClass["Heading"] = "iress-toast__heading";
    ToastCssClass["Footer"] = "iress-toast__footer";
    ToastCssClass["HasHeading"] = "iress-toast--has-heading";
    ToastCssClass["Wrapper"] = "iress-toast__wrapper";
    ToastCssClass["CloseButton"] = "iress-toast__close-button";
    ToastCssClass["Icon"] = "iress-toast__icon";
})(ToastCssClass || (ToastCssClass = {}));
export var ToastSlot;
(function (ToastSlot) {
    ToastSlot["Actions"] = "actions";
})(ToastSlot || (ToastSlot = {}));
export var ToastStatus;
(function (ToastStatus) {
    ToastStatus["Success"] = "success";
    ToastStatus["Error"] = "error";
})(ToastStatus || (ToastStatus = {}));
//# sourceMappingURL=toast.types.js.map